import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers, BadgeCheck, Award, Clock3, Building2, ArrowRight } from "lucide-react";
import { staffApi } from "../api";

// Admin → Master Data: hub with live counts, linking to the HRMS master-data managers + branches.
const CARDS = [
  { key: "departments", label: "Departments", to: "/app/hrms/departments", icon: Layers, endpoint: "/departments" },
  { key: "designations", label: "Designations", to: "/app/hrms/designations", icon: BadgeCheck, endpoint: "/master-data/designations" },
  { key: "grades", label: "Grades", to: "/app/hrms/grades", icon: Award, endpoint: "/master-data/grades" },
  { key: "shifts", label: "Shifts", to: "/app/hrms/shifts", icon: Clock3, endpoint: "/master-data/shifts" },
  { key: "branches", label: "Branches", to: "/app/admin/branches", icon: Building2, endpoint: "/branches" },
];

const MasterDataHub = () => {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const load = async () => {
      const results = await Promise.allSettled(CARDS.map((c) => staffApi.get(c.endpoint)));
      const next = {};
      results.forEach((r, i) => {
        if (r.status === "fulfilled" && Array.isArray(r.value.data)) next[CARDS[i].key] = r.value.data.length;
      });
      setCounts(next);
    };
    load();
  }, []);

  return (
    <div data-testid="master-data-hub">
      <h1 className="font-display text-2xl font-bold text-slate-900">Master Data</h1>
      <p className="mt-1 text-sm text-slate-500">Shared reference data used across HRMS and attendance. Managed centrally — changes apply everywhere instantly.</p>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`hub-card-${c.key}`}
            className="group bg-white border border-slate-200 hover:border-[#0A1128] p-6 transition-colors">
            <div className="flex items-center justify-between">
              <span className="w-10 h-10 bg-[#0A1128] text-white flex items-center justify-center">
                <c.icon size={16} className="text-[#E8574F]" />
              </span>
              <ArrowRight size={14} className="text-slate-300 group-hover:text-[#C5221F] transition-colors" />
            </div>
            <p className="mt-4 font-display text-sm font-bold text-slate-900">{c.label}</p>
            <p className="mt-1 text-xs text-slate-400" data-testid={`hub-count-${c.key}`}>
              {counts[c.key] != null ? `${counts[c.key]} configured` : "—"}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MasterDataHub;
